module.exports = __webpack_public_path__ + "img/__icon_SWAPBODY.08550006.svg";